export default "<div question-wrapper=\"presented\">\n    <div vc-recaptcha key=\"presented.sitekey\" ng-model=\"answer.recaptchaResponse\"></div>\n</div>"